import React, { Component } from "react";
import { Link } from "react-router-dom";

import arrow from "../chevron-left.svg";
import "./PostSidebar.css";

import Social from "./Social";

import { getCategory } from "./fetch/fetchApi";

class PostSidebar extends Component {
  constructor(props) {
    super(props);

    this.catsPrint = this.catsPrint.bind(this);
    this.switchSidebar = this.switchSidebar.bind(this);
    this.expandSidebar = this.expandSidebar.bind(this);

    this.state = {
      projectInfo: "title",
      categories: [],
      sidebarExpanded: false
    };
  }

  componentWillMount() {
    if (typeof this.props.post !== "undefined") {
      const cats = this.props.post.categories.join();
      const catReq = getCategory(cats);
      catReq.then(categories => {
        this.setState({ categories });
      });
    }
  }

  catsPrint() {
    const cats = this.state.categories;
    console.log(cats);
    if (typeof cats !== "undefined" && cats.length > 0) {
      return cats.map((cat, index) => {
        if (typeof cat !== "undefined") {
          return (
            <p key={index}>
              <Link to={`/projects/${cat.slug}/`}>#{cat.name}</Link>
            </p>
          );
        }
      });
    }
  }

  switchSidebar(element) {
    this.setState({ projectInfo: element });
  }

  expandSidebar(expanded) {
    this.setState({ sidebarExpanded: expanded });
  }

  render() {
    return (
      <div
        className={
          this.state.sidebarExpanded
            ? "post-sidebar post-sidebar--expanded"
            : "post-sidebar"
        }
      >
        <div className="post-sidebar__navigation">
          <ul>
            <li
              onClick={() => {
                this.switchSidebar("title");
              }}
              className={
                this.state.projectInfo === "related"
                  ? "post-sidebar__navigation--inactive"
                  : ""
              }
            >
              {this.props.post.title.rendered}
            </li>
            <li
              onClick={() => {
                this.switchSidebar("related");
              }}
              className={
                this.state.projectInfo === "title"
                  ? "post-sidebar__navigation--inactive"
                  : ""
              }
            >
              Related work
            </li>
          </ul>
        </div>
        {this.state.projectInfo === "title" ? (
          <div className="post-sidebar__content">
            <h2 className="post-sidebar__heading">
              About {this.props.post.title.rendered}
            </h2>
            <a
              title="Expand project info"
              onClick={() => {
                this.expandSidebar(!this.state.sidebarExpanded);
              }}
              className="post-sidebar__expander hide-for-medium"
            >
              <img src={arrow} alt="Expand sidebar" />{" "}
              {!this.state.sidebarExpanded ? "Expand" : "Collapse"} info
            </a>
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.post.content.rendered
              }}
            />
            <div className="post-sidebar__social">
              <Social />
            </div>
          </div>
        ) : (
          <div className="post-sidebar__content">
            <div className="post-sidebar__related">{this.catsPrint()}</div>
          </div>
        )}
      </div>
    );
  }
}

PostSidebar.propTypes = {};

export default PostSidebar;



// WEBPACK FOOTER //
// ./src/components/PostSidebar.js